export * from './coach/coach.component';
export * from './events/events.component';
export * from './players-slider/players-slider.component';
export * from './review-appointment/review-appointment.component';
export * from './skill/skill.component';
export * from './slider/slider.component';
export * from './video/video.component';
